import {ApiClient as Api} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {DifficultySummaries, PlantDto} from '../../types'

const QueryKey = 'difficulty-summaries'

export const usePlantDifficultySummaries = (
  plantId: string,
  options?: Omit<UseQueryOptions<DifficultySummaries, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const query = useQuery<DifficultySummaries, AxiosError>({
    queryKey: [QueryKey, plantId],
    queryFn: async ({signal}) => {
      const response = await Api.axiosInstance.get<PlantDto>(`/pom-questionnaires/${plantId}`, {
        signal
      })

      return response.data.scoring.difficultySummaries
    },
    staleTime: 1000 * 60 * 15, // 15 mins
    ...options
  })
  return query
}
